import React from "react";
import styles from "./Loading.module.css";

export const Loading = () =>
    <div className={styles.loader}></div>
